import { OnboardingAuditField, useRepositoryMutation } from '@mews-commander/data-access';
import { CommanderFormProps, useDialogForm, useHandledDialogFormControls } from '@mews-commander/form';
import { createZodFormResolver, lt, showSuccessAlert } from '@mews/framework';
import { AuditLogFormContent } from './AuditLogFormContent';
import { defaultValues, FormValues, schema } from './schema';

type UseUpdateActivityLogParams = Pick<UpdateActivityLogFormProps, 'auditList'>;

export const useUpdateActivityLog = ({ auditList }: UseUpdateActivityLogParams) => {
    return useDialogForm({
        id: 'update-activity-log',
        title: lt('GoLiveAuditsUpdateActivityLog'),
        cancelLabel: lt('Close'),
        saveLabel: lt('Submit'),
        renderForm: (props) => <UpdateActivityLogForm {...props} auditList={auditList} />,
    });
};

interface UpdateActivityLogFormProps extends CommanderFormProps {
    auditList: OnboardingAuditField[];
}

const UpdateActivityLogForm = ({ auditList, ...other }: UpdateActivityLogFormProps) => {
    const { mutateAsync } = useRepositoryMutation('enterprises', 'addOnboardingAuditLog', {
        invalidateQueries: {
            enterprises: ['getAllOnboardingAuditLogs'],
        },
        onSuccess: () => {
            showSuccessAlert({
                title: lt('GoLiveAuditsActivityLogUpdated'),
            });
        },
    });

    const { renderFormContent } = useHandledDialogFormControls<FormValues>({
        values: defaultValues,
        onSubmit: async (values) => mutateAsync({ ...values, fieldData: auditList }),
        resolver: createZodFormResolver(schema),
        ...other,
    });

    return renderFormContent(<AuditLogFormContent />);
};
